(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var sel = '.aev__section, .aev__vipcard, .aev__wallet, .aev__trust, .aev__faq details, .acol__card, .dbd-tour__row, .a404__art';
  var els = Array.prototype.slice.call(document.querySelectorAll(sel));
  if (!els.length) return;
  els.forEach(function (el, i) {
    el.classList.add('reveal');
    el.style.transitionDelay = Math.min(i % 8, 6) * 40 + 'ms';
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('reveal--in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  els.forEach(function (el) { io.observe(el); });
})();

/* sticky ADD TO CART: skrýt když je footer ve viewportu (nepřekrývat) */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var footer = document.querySelector('.shopify-section-group-footer-group');
  var stickies = Array.prototype.slice.call(document.querySelectorAll('.aev__sticky, .dbd-sticky'));
  if (!footer || !stickies.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      stickies.forEach(function (s) { s.classList.toggle('sticky-hidden', e.isIntersecting); });
    });
  }, { threshold: 0 });
  io.observe(footer);
})();

/* my-orders: override fixed bg to absolute so footer shows */
(function () {
  if (!document.querySelector('.orders-page')) return;
  var s = document.createElement('style');
  s.textContent = '.orders-page__bg-wrap{position:absolute!important}.orders-page__overlay{position:absolute!important}';
  (document.body || document.head).appendChild(s);
})();

/* cart: force body/html black */
(function () {
  if (!document.querySelector('.cart-page, [data-template="cart"]')) return;
  var s = document.createElement('style');
  s.textContent = 'html,body{background:#0a0a0a!important;background-color:#0a0a0a!important}';
  (document.body || document.head).appendChild(s);
})();

/* aev sticky bar: black background */
(function () {
  var s = document.createElement('style');
  s.textContent = '.aev__sticky{background:#0a0a0a!important;border-top:1px solid #262626!important}.aev__sticky-info{background:#0a0a0a!important}';
  (document.body || document.head).appendChild(s);
})();

/* header cart icon: always white */
(function () {
  var s = document.createElement('style');
  s.textContent = '.header-actions__cart-icon,header cart-icon,header cart-icon svg{color:#fff!important}';
  (document.body || document.head).appendChild(s);
})();

/* cart drawer: force dark */
(function () {
  var s = document.createElement('style');
  s.textContent = '.cart-drawer__dialog,.cart-drawer{background:#0a0a0a!important;color:#fff!important}' +
    '.cart-drawer__dialog *{color:#fff!important;border-color:#262626!important}' +
    '.cart-drawer__dialog .button--primary{background:#67c05f!important;color:#0a0a0a!important}' +
    '.cart-drawer__dialog input,.cart-drawer__dialog select{background:#141414!important;color:#fff!important;border-color:#262626!important}';
  (document.body || document.head).appendChild(s);
})();

/* addon checkboxes: force border visible + JS checked state */
(function () {
  var s = document.createElement('style');
  s.textContent = '.aev__addon-check{width:18px!important;height:18px!important;border:2px solid #444!important;background:#000!important;display:block!important;position:relative!important;flex-shrink:0!important;box-sizing:border-box!important}';
  (document.body || document.head).appendChild(s);

  function syncChecks() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-addon-id]'), function(input) {
      var check = input.nextElementSibling;
      if (!check || !check.classList.contains('aev__addon-check')) return;
      if (input.checked) {
        check.style.cssText = 'background:#67c05f!important;border-color:#67c05f!important;width:18px;height:18px;display:block;position:relative;flex-shrink:0';
        // draw checkmark via inner span
        if (!check.querySelector('i')) {
          var i = document.createElement('i');
          i.style.cssText = 'position:absolute;left:5px;top:1px;width:5px;height:9px;border:solid #000;border-width:0 2.5px 2.5px 0;transform:rotate(45deg);display:block';
          check.appendChild(i);
        }
      } else {
        check.style.cssText = 'background:#000!important;border-color:#444!important;width:18px;height:18px;display:block;position:relative;flex-shrink:0';
        var i = check.querySelector('i');
        if (i) i.remove();
      }
    });
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.aev__addon')) setTimeout(syncChecks, 0);
  });
})();

/* switch CZ country to GB if detected (CZK → GBP) */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var spans = document.querySelectorAll('.currency-code');
    var isCZK = Array.from(spans).some(function(s) { return s.textContent.trim() === 'CZK'; });
    if (!isCZK) return;
    var form = document.querySelector('form.localization-form');
    if (!form) return;
    var countryInput = form.querySelector('[name="country_code"]');
    if (countryInput) countryInput.value = 'GB';
    var returnTo = form.querySelector('[name="return_to"]');
    if (!returnTo) {
      var r = document.createElement('input');
      r.type = 'hidden'; r.name = 'return_to'; r.value = window.location.pathname;
      form.appendChild(r);
    }
    form.submit();
  });
})();
document.addEventListener('DOMContentLoaded', function () {
  var cd = document.querySelector('[data-countdown]');
  if (!cd) return;
  if (cd.querySelector('[data-cd="d"]').textContent !== '–') return; // already running
  var target = new Date(cd.getAttribute('data-countdown')).getTime();
  if (isNaN(target)) return;
  var els = {
    d: cd.querySelector('[data-cd="d"]'),
    h: cd.querySelector('[data-cd="h"]'),
    m: cd.querySelector('[data-cd="m"]'),
    s: cd.querySelector('[data-cd="s"]')
  };
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var diff = Math.max(0, target - Date.now());
    if (els.d) els.d.textContent = Math.floor(diff / 86400000);
    if (els.h) els.h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
    if (els.m) els.m.textContent = pad(Math.floor((diff % 3600000) / 60000));
    if (els.s) els.s.textContent = pad(Math.floor((diff % 60000) / 1000));
  }
  tick();
  setInterval(tick, 1000);
});

/* my-orders login button text */
(function () {
  var s = document.createElement('style');
  s.textContent = '.orders-login__button,.orders-login__button:hover,.orders-login__button:visited{color:#0a0a0a!important}';
  (document.body || document.head).appendChild(s);
})();
